<template lang="pug">
    #modal-editar-protocolo-default
        el-dialog(
            width='40%',
            title='Escolha um protocolo como o padrão',
            :visible.sync='mostrar',
            :close-on-click-modal='false',
            :before-close='fechar'
        )
            el-card(shadow='never', :body-style='{ padding: "10px" }')
                        el-table(
                            ref="tabelaProtocoloDefault",
                            :data="protocolos",
                            size='mini',
                            highlight-current-row,
                            height='350px',
                            @current-change="handleProtocoloDefault"
                        )
                            el-table-column(property="descricao", label="Nome", sortable, :min-width="100")
            footer(slot='footer')
                BaseButton(size='mini', @click='fechar') Cancelar
                BaseButton(size='mini', type='primary' :disabled="!this.protocoloDefault", @click='confirmarProtocoloDefault') Confirmar
</template>

<script>
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
export default {
    name: 'ModalEditarProtocoloDefault',

    components: {
        BaseButton
    },

    props: {
        mostrar: {
            type: Boolean,
            required: true
        },
        protocolos: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            protocoloDefault: ''
        };
    },

    methods: {
        fechar() {
            this.$emit('fechar');
            this.protocoloDefault = '';
        },
        confirmarProtocoloDefault() {
            if (this.protocoloDefault) {
                this.$emit('vincularProtocoloEmpresa');
                this.$emit('fechar');
                this.protocoloDefault = '';
            } else {
                this.$notify.error({ message: 'Protocolo padrão não selecionado!' });
            }
        },
        limparSelecoes() {
            this.$refs.tabelaProtocoloDefault.clearSelection();
        },
        handleProtocoloDefault(value) {
            this.protocoloDefault = value.codigo;
            this.$emit('setSelectedProtocoloAsDefault', this.protocoloDefault);
        }
    }
};
</script>
